// components/admin/accounting/modals/ImageViewModal.jsx
import React from 'react';
import { X, Eye, Trash2, Image as ImageIcon } from 'lucide-react';

function ImageViewModal({
  isOpen,
  images,
  isLoading,
  onClose,
  onDelete
}) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-white border-b border-slate-200 p-6">
          <div className="flex items-center justify-between">
            <h3 className="text-xl font-bold text-slate-800 font-montserrat">
              Comprobantes de Pago
            </h3>
            <button
              onClick={onClose}
              className="text-slate-400 hover:text-slate-600 transition-colors"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>

        <div className="p-6">
          {isLoading ? (
            <div className="flex items-center justify-center py-12">
              <div className="text-slate-600 font-montserrat">Cargando imágenes...</div>
            </div>
          ) : images.length === 0 ? (
            <div className="text-center py-12">
              <ImageIcon className="w-16 h-16 mx-auto mb-4 text-slate-300" />
              <p className="text-slate-600 font-montserrat">
                No hay comprobantes subidos aún
              </p>
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {images.map((image) => (
                <div key={image.id} className="relative group">
                  <img
                    src={image.image_url}
                    alt="Comprobante"
                    className="w-full h-64 object-cover rounded-lg border border-slate-200 cursor-pointer"
                    onClick={() => window.open(image.image_url, '_blank')}
                  />
                  <div className="absolute top-2 right-2 flex gap-2">
                    <button
                      onClick={() => window.open(image.image_url, '_blank')}
                      className="p-2 bg-brand-primary text-white rounded-lg opacity-0 group-hover:opacity-100 transition-opacity"
                      title="Abrir en nueva pestaña"
                    >
                      <Eye className="w-4 h-4" />
                    </button>
                    <button
                      onClick={() => onDelete(image.id)}
                      className="p-2 bg-red-500 text-white rounded-lg opacity-0 group-hover:opacity-100 transition-opacity"
                      title="Eliminar imagen"
                    >
                      <Trash2 className="w-4 h-4" />
                    </button>
                  </div>
                  <p className="text-xs text-slate-500 mt-2 font-montserrat">
                    {new Date(image.uploaded_at).toLocaleString('es-PE')}
                  </p>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ImageViewModal;